import * as Yup from 'yup';

export const ContactUsFormSchema = () =>
  Yup.object().shape({
    name: Yup.string().required('Please enter your name.'),
    email: Yup.string().email('Invalid email format').required('Please enter your email.'),
    dealershipName: Yup.string().max(
      50,
      'Dealership name is too long - should be 50 chars maximum',
    ),
    enquiryPurpose: Yup.object()
      .required('Location is required.')
      .test(
        'has-value',
        'Please select the purpose of your enquiry.',
        (value) => value && value.value !== '',
      ),
    message: Yup.string()
      .max(250, 'Enquiry is too long - should be 200 chars maximum')
      .required('Please enter your message.'),
    terms: Yup.boolean().oneOf(
      [true],
      'You need to accept the Cookie and Privacy Policy before submitting.',
    ),
  });
